import { Search } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useCommandPaletteStore } from '~/lib/store/command-palette';

/** Topbar pill that opens the command palette. Mirrors the ⌘K affordance. */
export function SearchTrigger() {
	const { t } = useTranslation();
	const setOpen = useCommandPaletteStore(s => s.setOpen);
	return (
		<button
			type="button"
			onClick={() => setOpen(true)}
			className="flex h-[30px] items-center gap-2 rounded-md border border-border bg-elevated px-2.5 text-foreground-subtle transition-colors hover:text-foreground">
			<Search size={13} />
			<span className="text-[11.5px]">{t('shell.search.label')}</span>
			<kbd className="rounded bg-muted px-1 py-0.5 font-mono text-[10px] text-foreground-subtle">⌘K</kbd>
		</button>
	);
}
